module.exports = __webpack_public_path__ + "img/logo.bcb92501.png";